import myAxios from './myAxios';
import * as episodesActions from './episodesActions';

export const fetchStory = storyId => (
  (dispatch) => {
    return myAxios.get(routes().get_story + storyId)
      .then((response) => {
        dispatch(episodesActions.fetchEpisodesSuccess(response.data));
        dispatch(fetchStorySuccess(response.data));
        return response.data;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const fetchStorySuccess = (payload) => ({type: 'FETCH_STORY_SUCCESS', payload });

export const storyToggleSubscribe = (story) => {
  let endpoint = api_host + '/user/subscriptions/' + story.id;
  let options = { method: (story.subscribed ? 'DELETE' : 'POST'), headers: getHeaders() };
  let request = new Request(endpoint, options);

  return (dispatch) => {
    fetch(request)
      .then((response) => { return response;})
      .then((response) => response.json())
      .then(() => dispatch(storyToggleSubscribeSuccess()))
  }
};

export const storyToggleSubscribeSuccess = () => ({type: 'STORY_TOGGLE_SUBSCRIBE_SUCCESS'});
